import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { QuickOrderFormComponent } from '@spartacus/cart/quick-order/components';
import { Config, GlobalMessageService, GlobalMessageType, Product, WindowRef } from '@spartacus/core';
import { QuickOrderFacade } from '@spartacus/cart/quick-order/root';
import { GenBaseStoreService } from 'src/app/generac/services/base-store.service';

@Component({
    selector: 'gen-quick-order-form',
    templateUrl: './quick-order-form.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GenQuickOrderFormComponent extends QuickOrderFormComponent {
  override results: Product[] = [];

  constructor(
    config: Config,
    cd: ChangeDetectorRef,
    quickOrderService: QuickOrderFacade,
    winRef: WindowRef,
    private globalMessageService: GlobalMessageService,
    private baseStoreService: GenBaseStoreService
  ) {
    super(config, cd, quickOrderService, winRef);
  }

  override focusNextChild(event: UIEvent | Event): void {
    event.preventDefault();
    if (!this.results.length) {
      return;
    }
    const [results, focusedIndex] = [
      this.getResultElements(),
      this.getFocusedIndex(),
    ];
    if (results.length) {
      if (focusedIndex >= results.length - 1) {
        results[0].focus();
      } else {
        results[focusedIndex + 1].focus();
      }
    }
  }

  override focusPreviousChild(event: UIEvent | Event): void {
    event.preventDefault();
    if (!this.results.length) {
      return;
    }
    const [results, focusedIndex] = [
      this.getResultElements(),
      this.getFocusedIndex(),
    ];
    if (results.length) {
      if (focusedIndex < 1) {
        results[results.length - 1].focus();
      } else {
        results[focusedIndex - 1].focus();
      }
    }
  }

  onAdd(product: Product, event: Event) {
    if (!product.price?.formattedValue) {
      this.baseStoreService.getPhoneNumber().subscribe((phoneNumber) => {
        this.globalMessageService.add(
          {
            key: 'quickOrderForm.productNoPrice',
            params: { phoneNumber: phoneNumber?.contactInfo },
          },
          GlobalMessageType.MSG_TYPE_ERROR
        );
      });
      return;
    }

    this.add(product, event);
  }
}
